import State from "slotworks/state-machine/states/state";
import gameState from "slotworks/model/game-state";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import Components from "slotworks/components/components";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import BuyoutRecord from "integration/records/buyout-record";
import FreespinsWheelResult from "integration/results/freespins-wheel-result";

export default class Buyout extends State {

    public onEnter() {
        this.newGame();
        this.complete();
    }

    private newGame() {
        const buyoutRecord = gameState.getCurrentGame().latestRecord() as BuyoutRecord;

        gameState.newGame();
        gameState.getCurrentGame().isBuyout = true;
        regulation.interactionStart();
        Components.betBar.winnings.setWinnings(0, 0);

        Components.betBar.setBalance(gameState.getCurrentGame().startBalance);
        Components.betMenu.setBalance(gameState.getCurrentGame().startBalance);

        const record = new SpinRecord();
        record.creditsWon = 0;
        record.reelset = [];
        record.grid = [];
        record.stops = [];
        const bonusResult = new FreespinsWheelResult();
        bonusResult.buyout = true;
        record.results = [bonusResult];

        gameState.getCurrentGame().isRecovered = true;
        gameState.getCurrentGame().records.push(record);
    }

}